import { z } from 'zod';

// v1 learning from real conversations (mapa de producto «Aprender de la operación real»; especificación «Corrección y
// prueba desde la app»): mark a real LIA reply + an internal note → a test reply under the original (team only, never
// sent) → an editable instruction proposal for the project → applied to the project's instructions DRAFT (published
// through the normal flow, gated by the project's must-pass cases) → optionally saved as a test case.

const Id = z.string().min(1).max(64);
const Iso = z.string();

export const MESSAGE_CORRECTION_STATUSES = ['proposed', 'applied', 'rejected'] as const;
export const MessageCorrectionStatusSchema = z.enum(MESSAGE_CORRECTION_STATUSES);
export const MESSAGE_CORRECTION_STATUS_LABELS: Record<(typeof MESSAGE_CORRECTION_STATUSES)[number], string> = {
  proposed: 'Propuesta',
  applied: 'En el borrador del proyecto',
  rejected: 'Descartada',
};

export const MessageCorrectionSchema = z.object({
  id: Id,
  projectId: Id,
  conversationId: Id,
  messageId: Id,
  note: z.string(),
  status: MessageCorrectionStatusSchema,
  /** Test reply generated with the context up to the marked message + the note. Team only; never sent. */
  testReply: z.string().nullable(),
  testReplyError: z.string().nullable(),
  proposedInstruction: z.string().nullable(),
  /** The instruction as the team edited it (what is applied). */
  instruction: z.string().nullable(),
  appliedDraftVersion: z.number().int().nullable(),
  appliedAt: Iso.nullable(),
  testScenarioId: Id.nullable(),
  createdByName: z.string().nullable(),
  createdAt: Iso,
});
export type MessageCorrection = z.infer<typeof MessageCorrectionSchema>;

export const CreateMessageCorrectionSchema = z.object({ note: z.string().trim().min(3).max(1000) });
export const UpdateMessageCorrectionSchema = z.object({ instruction: z.string().trim().min(3).max(2000) });
export const SaveCorrectionCaseSchema = z.object({
  name: z.string().trim().min(2).max(120),
  /** Expected behaviour in the team's words (judged on every run). */
  criterion: z.string().trim().min(3).max(500),
  mustPass: z.boolean().default(false),
});
